module.exports = __webpack_public_path__ + "img/img.f72b17ac.jpg";